var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('GridIntroSection'),_c('GridIntroTwoSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }